import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/react"
import { Toaster } from 'sonner'
import './index.css'
// Side-effect import: initialises the OpenTelemetry WebTracerProvider before
// React renders so auto-instrumentations (fetch, document-load) capture every
// request from app start.
import './lib/telemetry'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { SessionsProvider } from './contexts/SessionsContext.jsx'

Sentry.init({
  dsn: "https://6890726d30c2552bb98030b2e99f7414@o4510113739702272.ingest.de.sentry.io/4510113752023120",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
})

const container = document.getElementById('root')
if (!container) throw new Error('Root container missing in index.html')
const root = createRoot(container)
root.render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SessionsProvider>
          <App />
          <Toaster position="top-center" richColors />
        </SessionsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
